<div id="payment_form"><h4>Pay by Telecheck</h4>
  <ng-container *ngIf="!paymentFormWidgetService.telecheckDeclined"
                [ngTemplateOutlet]="telecheckPayment"></ng-container>
  <ng-container *ngIf="paymentFormWidgetService.telecheckDeclined"
                [ngTemplateOutlet]="telecheckDeclined"></ng-container>
</div>

<tg-spinner [blockAll]="true" *ngIf="isItLoading()"></tg-spinner>

<ng-template #telecheckPayment>
  <div class="payment-terms-wrapper">
    <p>Payment is accepted via the <a
      href="https://www.nar.realtor/narfininfo.nsf/pages/realtorecommerceNetwork?OpenDocument" target="_blank">REALTORS®
      ECommerce Network</a> (RECN) operated by the National Association of REALTORS®
      (NAR). Payments for dues and other fees shown on your member invoice are non-refundable.</p>
    <p>To proceed with this payment, you must check the box below to confirm that you understand and accept
      the Association's <a [href]="variablesService.paymentPolicy" target="_blank">payment and refund policies</a> and
      terms of the TeleCheck Transaction Authorization below (collectively the <b>Payment Terms</b>).</p>
  </div>

  <div class="images-wrapper">
    <div class="telecheck-brand-wrapper">
      <div class="telecheck-brand">Check Payments are processed by TeleCheck.</div>
    </div>
    <img class="check-example" src="/assets/images/payments/telecheck/check.png"/>
  </div>

  <form (ngSubmit)="makePayment()">
    <tgf-form-control-question-processor
      [parentModel]="actualModel"
      [questionsToInclude]="['TeleCheckTermsOfPayment']"
      [form]="questionForm" [questionJson]="questionJson">
    </tgf-form-control-question-processor>

    <div class="row mt-3">
      <div class="col-sm-12">
        <tgf-form-control-question-processor
          [parentModel]="actualModel"
          [form]="questionForm" [questionJson]="questionJson"
          [questionsToInclude]="['AccountName', 'CheckNumber', 'MICRNumber']"
        >
        </tgf-form-control-question-processor>
      </div>

      <div class="row mt-3">
        <div class="col-sm-12">
          <tgf-address-form-widget [form]="questionForm"
                                   [requiresValidation]="false"
                                   [inputModel]="getAddressFormModel()"
                                   [parentModel]="actualModel">
          </tgf-address-form-widget>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-sm-12">
          <tgf-form-control-question-processor
            [parentModel]="actualModel"
            [questionsToInclude]="['emailaddress', 'DriversLicenseNumber','DriversLicenseState','DateOfBirth', 'AccountType']"
            [form]="questionForm" [questionJson]="questionJson">
          </tgf-form-control-question-processor>
        </div>
      </div>

      <div>
      </div>
    </div>

    <div class="telecheck-terms-wrapper">
      <p class="telecheck-terms"><strong>Transaction Authorization:</strong> Today, <span id="today">10 Mar, 2025</span>,
        I, <strong>{{ getPersonFullName() }}</strong>, by entering my routing and account number above and clicking
        "Pay"
        below, I
        authorize my payment in the amount indicated below to be processed as an electronic funds transfer (EFT) or
        draft
        drawn from my checking or savings account as indicated above and, if necessary, to have my account
        electronically
        credited to correct erroneous debits. I understand that my payment will be processed within 1 - 2 banking days.
        If
        the payment returns unpaid, I authorize you or your service provider to collect the payment and my state's
        return
        item fee and, if applicable, costs, by EFT(s) or draft(s) drawn from my account. <a
          href="https://www.firstdata.com/support/TeleCheck_returned_check/returned_check_fees.html" target="_blank">Click
          here to view your state’s returned item fee</a> and, if applicable, costs. I understand that this
        authorization
        will remain in full force and effect until I notify you that I wish to revoke it by calling my association to
        inquire on any refund policy and allow you reasonable opportunity to act on my notice. For more information on
        TeleCheck’s process and privacy policy, see <a href="https://getassistance.telecheck.com/faq.html"
                                                       target="_blank">Internet Check FAQ</a> and <a
          href="https://www.firstdata.com/telecheck/privacy.html" target="_blank">TeleCheck Privacy Policy</a>.</p>
    </div>

    <div class="payment-error" *ngIf="paymentFormWidgetService.paymentErrorMessage"
         [innerHTML]="paymentFormWidgetService.paymentErrorMessage">
    </div>

    <div class="payment-buttons-wrapper">
      <button
        class="sd-btn sd-btn--action ms-auto"
        [disabled]="isItLoading()">
        Pay {{ StringUtils.toMoney(totalCharge) }}
      </button>
    </div>
    <div id="payment_result"></div>
  </form>
</ng-template>

<ng-template #telecheckDeclined>
  <div class="telecheck-error">
    <div class="error-title"><i class="fa-regular fa-circle-x error-icon"></i><h4>Sorry, TeleCheck Cannot Approve This
      Transaction</h4></div>
    <p>We are sorry that we cannot complete your transaction. Our decision was based, in part, on information provided
      by TeleCheck.</p>
    <p>What is TeleCheck? <span>TeleCheck provides payment acceptance, account screening, and fraud prevention services to both merchants and financial institutions by reporting on check writing histories. Please visit https://getassistance.telecheck.com/index.html to learn more about TeleCheck.</span>
    </p>
    <p>Why does TeleCheck need personal information about you before we can assist you? <span>The use of some types of personal information, including bank account details and/or a driver’s license number, is needed to verify TeleCheck is communicating with the right person about the right records. TeleCheck may even request a social security number in order to locate and verify records reported by a bank or credit union. To a consumer worried about identity theft, this may seem like a lot to ask. However, TeleCheck only requests what is needed to ensure the accuracy of data.</span>
    </p>
    <p>You may have received a decline because of unpaid debt associated with your checking account. <span>TeleCheck will issue a decline alert if it has at least one record in its files of unpaid debt associated with your bank account and/or personal information. This type of a decline code is referred to as a “Code 4 (804)”. We encourage you to contact TeleCheck to learn more details about the information in its records and what you can do to resolve any issues related to your receipt of a Code 4 decline.</span>
    </p>
    <p>You may have received a risk-based decline. <span>TeleCheck analyzes transactions to determine whether they appear to be potentially high risk to protect consumers, merchants, and financial institutions from fraud and losses. How did TeleCheck determine this “potential risk?” Through the use of modeling tools built on the detection of common characteristic groupings observed in past transactions, TeleCheck statistically determines the likelihood that a payment may return. So, while there may have been nothing wrong with your transaction, it had certain characteristics that made TeleCheck question it. Receiving a risk decline does not signify to you -- or anyone else -- that TeleCheck holds records of bad check writing history on you. And, it does not mean you do not have enough money in the bank to cover your payment. TeleCheck has no visibility into your bank account balance. And finally, it has absolutely no effect on your credit. These risk models provide critical protection against fraud. A Code 3 (805) is often the first alert a consumer receives that their account has been fraudulently compromised. Risk modeling also enables merchants to continue to safely accept their customers’ checks by minimizing fraud-related losses, and controlled loss brings cost benefits to customers.</span>
    </p>
    <p>To learn more: <span>You may call or write TeleCheck for further information. You will need to provide (1) the declined transaction’s record number (if provided), (2) your driver’s license number and its state of issuance (3) if applicable, the bank routing and account number you used for the declined transaction, and (4) your social security number (if the declined transaction was with a financial institution).</span>
    </p>
    <p>Contact information:<br/>TeleCheck Services, Inc.<br/>ATTN: Resolutions Department P. O. Box 6806<br/>Hagerstown,
      MD 21741-6806 Tel: 1-800-366-2425<br/><a href="https://getassistance.telecheck.com/index.html"
                                               target="_blank">getassistance.telecheck.com</a></p>
    <p>Under the Fair Credit Reporting Act: Consumers have the right to a free copy of their information held in
      TeleCheck’s files for a period of 60 days following an adverse action. Consumers also may dispute the accuracy or
      completeness of any information in TeleCheck’s consumer report. TeleCheck did not make the decision to take an
      adverse action (i.e., to not accept a payment or approve the opening of an account) and is unable to provide you
      with specific reasons as to why an adverse action was taken.</p>
    <p class="action">You will need to pay via Credit Card to continue. <a class="switch-to-credit-card-link"
                                                                           (click)="switchToCreditCard()">Pay now by
      Credit Card</a>.
    </p>
  </div>
</ng-template>
